
import Vue from 'vue'
/**
 * 日期格式化
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('wq_capitalize', (value, f) => {
  if(!value) return '';
  if(!f) f = 'yyyy-MM-dd hh:mm';
  var elem = new Date(value.replace(/-/g, '/'));
  var o ={
    "M+" : elem.getMonth()+1, //月
    "d+" : elem.getDate(),    //d日
    "h+" : elem.getHours(),   //时
    "m+" : elem.getMinutes(), //分
    "s+" : elem.getSeconds(), //秒
    "q+" : Math.floor((elem.getMonth()+3)/3),
    "S" : elem.getMilliseconds()
  }
  if(/(y+)/.test(f)) f=f.replace(RegExp.$1,(elem.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o) if(new RegExp("("+ k +")").test(f))f = f.replace(RegExp.$1,RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
  return f
});


/**
 * 日期格式化并计算时长
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('duration', (times) => {
  if(!times) return '';
  // var timer = setInterval(function(){
  //   var leftTime = (new Date(times)) - (new Date()); //计算剩余的毫秒数
  //   var days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10); //计算剩余的天数
  //   var hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10); //计算剩余的小时
  //   var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
  //   var seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
  //   var timehtml='剩余'+days+'天'+hours+'小时' + minutes+'分'+seconds+'秒';
  //   return timehtml
  // },1000);
    var nowTime = new Date()
    var leftTime = (new Date(times)) - nowTime;
    var days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10); //计算剩余的天数
    var hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10); //计算剩余的小时
    var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
    var seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
    var timehtml='剩余'+days+'天'+hours+'小时' + minutes+'分'+seconds+'秒';
    return timehtml;
});
/**
 * 数组处理
 *  **/
Vue.filter('arrayTo', (value, f) => {
  if(!value) return false;
  var arrStr = ''
  value.forEach(function (c) {
    arrStr += c;
  })
  return arrStr
});



/**
 * 超出三个点显示
 * eg:中文8个字英文16个字
 *
 *  **/
Vue.filter('ellipsisEight', (value) => {
  // var reg = /^[\\u4E00-\\u9FA5]+$/;
  // if (!reg.test(value)){
  // if(escape(value).indexOf("%u")<0){
  //   // console.log( "不全是中文" );
  //   if(value.length > 16){
  //     return value.substring(0,15)+'...'
  //   }else{
  //     return value
  //   }
  // } else {
    // console.log( "全是中文" );
    if(value.length > 32){
      return value.substring(0,32)+'...'
    }else{
      return value
    }
  // }
});

/**
 * 根据国家代码显示国家名称
 * eg:AZ——"阿塞拜疆"
 *
 *  **/
Vue.filter('alpha2CodeToName', (value,arr) => {
  if(!value) return '';
  for (let i = 0; i < arr.length; i++) {
    if(arr[i].alpha2Code == value){
      return arr[i].cnName
    }
  }
});

Vue.filter('ellipsisEight', (value) => {
  if (!value) return ''
  if(escape(value).indexOf("%u")<0){
    // console.log( "不全是中文" );
    if(value.length > 16){
      return value.substring(0,15)+'...'
    }else{
      return value
    }
  } else {
    // console.log( "全是中文" );
    if(value.length > 8){
      return value.substring(0,8)+'...'
    }else{
      return value
    }
  }
});
// 使用性质filter  FYY 非营运
Vue.filter('usageAttributeTran', (usageAttribute) => {
  let usageAttributeStr = "未知使用性质";
  if(usageAttribute == "FYY"){
    usageAttributeStr = "非营业";
  }else if(usageAttribute == "YY"){
    usageAttributeStr = "营业";
  }
  return usageAttributeStr;
});
/**
 * 证件类型filter 1 身份证
 * @param identityType
 */
Vue.filter('identityType', (identityType) => {
  let identityTypeStr = "未知证件类型";
  if(identityType == 1){
    identityTypeStr = "身份证";
  }else if(identityType == 6){
    identityTypeStr = "回乡证或台胞证";
  }else if(identityType == 5){
    identityTypeStr = "营业执照";
  }
  return identityTypeStr;
});

/**
 * 金额格式化
 * @param moneyStr
 */
Vue.filter('moneyFormat', (money) => {
  if (money && money != null) {
    money = String(money);
    var left = money.split('.')[0], right = money.split('.')[1];
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
    return '￥'+(Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
  } else if (money === 0) {
    return '￥'+'0.00';
  } else {
    return '';
  }
});
// 保额格式化
Vue.filter('premiumStr', (premium,coverCode,seats,fixDays) => {
  if(coverCode == 'C_05'){
    return `${seats}座x${premium/10000}万`
  }else if(coverCode == 'C_34'){
    return seats > 0 ? `${premium*seats/10000}万`:`${premium/10000}万`
  }else if(coverCode == 'C_36'){
    if(premium == 0 ) return `共享保额`
    return seats > 0 ? `${seats}座X${premium/10000}万`:`${premium/10000}万`
  } else if(coverCode == 'C_10'){
    return `${fixDays}天x${premium}元/天`
  }else if(coverCode=='C_20'||coverCode=='C_21'||coverCode=='C_22'||coverCode=='C_23'){
    return `${premium}次`
  }else if(coverCode=='C_25'||coverCode=='C_29'||coverCode=='C_32'||coverCode=='C_35'){
    return `${premium}%`
  }else if(coverCode=='C_30'||coverCode=='C_33'){
    return premium == 0 ? '共享保额' : `${premium/10000}万`
  }else if(coverCode=='C_01' || coverCode=='C_39' ||  coverCode=='C_03'){
    return premium
  }else{
    if(premium<10000){
      return premium === 0.0 ? '':premium
    }else{
      return `${premium/10000}万`
    }

  }
});

// 充电桩种类 1:地面充电桩 2:壁挂式充电桩 3:其他类充电桩
Vue.filter('chargingPileTypeStr', (value) => {
  const arr = ['','地面充电桩','壁挂式充电桩','其他类充电桩']
  return arr[value] || ''
});


 //安装地点 1:地面停车场 2:地面停车楼 3:地下停车场
Vue.filter('installLocationStr', (value) => {
  let str = ''
  if (!value) return
  switch (Number(value)) {
    case 1:
      str = '地面停车场';
      break;
    case 2:
      str = '地面停车楼';
      break;
    case 3:
      str = '地下停车场';
      break;
  }
  return str
});

//使用年限 1:2年以内 2:2~5(含)年 3:5年以上
 Vue.filter('usefulLimitStr', (value) => {
  let str = ''
  if (!value) return
  switch (Number(value)) {
    case 1:
      str = '2年以内';
      break;
    case 2:
      str = '2~5(含)年';
      break;
    case 3:
      str = '5年以上';
      break;
  }
  return str
});

export default {}



// WEBPACK FOOTER //
// ./src/public/filters.js